export const GET_USER_NOTIFICATIONS: string = 'GET_USER_NOTIFICATIONS';
export const GET_USER_NOTIFICATIONS_SUCCESS: string = 'GET_USER_NOTIFICATIONS_SUCCESS';
export const UPDATE_SEEN_STATUS: string = 'UPDATE_SEEN_STATUS';
export const UPDATE_USER_NOTIFICATIONS: string = 'UPDATE_USER_NOTIFICATIONS';
export const DELETE_USER_NOTIFICATION: string = 'DELETE_USER_NOTIFICATION';
export const RESET_USER_NOTIFICATIONS: string = 'RESET_USER_NOTIFICATIONS';